import { formatTimeRange, getStartEnd } from '@logz-pkg/utils';
import { partition } from 'lodash';
import { QUERY_SOURCE_PREFIX } from './constants';
const extractFieldsFromSortArr = (sort) => {
    const [timeStampFieldArr, nonTimestampFieldArr] = partition(sort, field => field.includes('@timestamp'));
    const timeStampField = timeStampFieldArr?.[0];
    const secondField = nonTimestampFieldArr?.[0];
    return { timeStampField, secondField };
};
const getAccountsWithPrefix = (accountIds) => {
    return accountIds.map(accountId => `${QUERY_SOURCE_PREFIX}${accountId}`);
};
export const luceneDslUtils = {
    extractFieldsFromSortArr,
    getAccountsWithPrefix,
    formatTimeRange,
    getStartEnd,
};
//# sourceMappingURL=utils.js.map